import React from 'react';

import Icon, { Props } from '../icon';

export const FailureIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40" fill="none">
      <path
        d="M20.0004 0C8.97516 0 0 8.99801 0 20.0513C1.10002 46.6568 38.9007 46.6443 40.0007 20.0513C40.0007 8.99801 31.0256 0 20.0004 0Z"
        fill="#F84049"
      />
      <path
        d="M28.423 10.1003C28.8298 9.69376 29.4893 9.69375 29.896 10.1003C30.3026 10.5071 30.3026 11.1666 29.896 11.5734L21.471 19.9984L29.896 28.4231C30.3025 28.8299 30.3027 29.4894 29.896 29.8961C29.4893 30.3028 28.8298 30.3026 28.423 29.8961L19.998 21.4714L11.577 29.8924C11.1703 30.2989 10.5108 30.2989 10.104 29.8924C9.69742 29.4856 9.69743 28.8261 10.104 28.4193L18.525 19.9984L10.1039 11.577C9.6972 11.1702 9.6971 10.5108 10.1039 10.104C10.5106 9.69725 11.17 9.69735 11.5769 10.104L19.998 18.5253L28.423 10.1003Z"
        fill="#F2F2F2"
      />
    </Icon>
  );
};

export default FailureIcon;
